"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Merge = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8.5,3.79289322 L11.8535534,7.14644661 C12.0488155,7.34170876 12.0488155,7.65829124 11.8535534,7.85355339 C11.679987,8.02711974 11.4105626,8.04640489 11.2156945,7.91140884 L11.1464466,7.85355339 L9,5.70689322 L9,6.99889322 L9.01294566,6.99973783 C9.00435077,7.16540461 9,7.33219422 9,7.5 C9,12.5792356 12.9861065,16.7274662 18.0007338,16.987106 L18.0002034,17.9883144 C14.016435,17.8016289 10.6132002,15.3949044 8.99973091,11.9773727 L9,19 L8,19 L8,5.70689322 L5.85355339,7.85355339 C5.67998704,8.02711974 5.41056264,8.04640489 5.2156945,7.91140884 L5.14644661,7.85355339 C4.97288026,7.67998704 4.95359511,7.41056264 5.08859116,7.2156945 L5.14644661,7.14644661 L8.5,3.79289322 Z" })));
};
Merge.displayName = 'Merge';
exports.default = Merge;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Merge.js.map